import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, RadioFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectCurrencyExchangeOptions, selectLoanSumOptions, moneyInAccOptions } from "@redux";

export const PlanServiceTurn = ({ control }) => {
  const currencyExchangeOptions = useSelector(selectCurrencyExchangeOptions);
  const loanOptions = useSelector(selectLoanSumOptions);
  const moneyInAccountOptions = useSelector(moneyInAccOptions);

  return (
    <StepperFormRow>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name="planServTurn.0.planServTurn"
        defaultValue="PEN1"
        className="d-none"
      />

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="planServTurn.0.data.currExchange"
          title={trb(i18.Labels.CurrExc)}
          options={currencyExchangeOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="planServTurn.0.data.loanSum"
          title={trb(i18.Labels.Loan)}
          options={loanOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="planServTurn.0.data.moInAcc"
          title={trb(i18.Labels.MoneyInAcc)}
          options={moneyInAccountOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
